import React, { useState, useEffect, useRef } from 'react';

const Tooltip = ({ children, text, position = 't', classes = '', delay = 100 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef(null);
    const tooltipRef = useRef(null);

    // Pulizia del timeout quando il componente viene smontato
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const getPopupClasses = () => {
        const baseClasses = 'absolute text-center bg-gray-100 dark:bg-neutral-900 text-black dark:text-white border border-gray-300 dark:border-gray-600 rounded-md p-2 shadow-md min-w-[200px] max-w-[300px] text-sm font-normal leading-none z-999';
        switch (position) {
            case 't':
                return `${baseClasses} bottom-full left-1/2 transform -translate-x-1/2 mb-1`;
            case 'r':
                return `${baseClasses} left-full top-1/2 transform -translate-y-1/2 ml-1`;
            case 'b':
                return `${baseClasses} top-full left-1/2 transform -translate-x-1/2 mt-1`;
            case 'l':
                return `${baseClasses} right-full top-1/2 transform -translate-y-1/2 mr-1`;
            default:
                return baseClasses;
        }
    };

    const handleMouseEnter = () => {
        timeoutRef.current = setTimeout(() => {
            setIsVisible(true);
        }, delay);
    };

    const handleMouseLeave = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsVisible(false);
    };

    return (
        <div
            className={`relative inline-block ${classes}`}
            ref={tooltipRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {children}
            {isVisible && (
                <div className={getPopupClasses()}>
                    {text}
                </div>
            )}
        </div>
    );
};

export default Tooltip;